import React, { ReactNode } from 'react';
import { DateValue, SelectorValue, SimpleValue } from 'src/components/Flowsteps/base/FilterManager';
import { isSubstitutionPattern } from "shared/utils/querySubstitution";
import { HSField } from '@v2/types/data';
import {
    RangeValueEditor
} from 'src/v2/components/controls/FilterManager/value-editors/RangeValueEditor/RangeValueEditor';
import { DataField } from 'shared/providers/types';
import { HubspotFieldEditorProps } from './types';

const DefaultEditor: React.FC<HubspotFieldEditorProps & { disableMultiply?: boolean }> = ({ value, onChange, disableMultiply }) => {
    const hasMultipleValues = !disableMultiply && value?.includes(',');
    return (
        <SimpleValue
            value={value}
            onChange={onChange}
            plural={hasMultipleValues}
        />
    )
}

const DateTimeEditor: React.FC<HubspotFieldEditorProps> = ({ value, onChange }) => {
    const isSubstitution = isSubstitutionPattern(value);
    return (
        <DateValue
            value={value}
            onChange={onChange}
            fieldType={'datetime'}
            isSubstitution={isSubstitution} />
    );
};

const typeEditorMap: Record<string, React.FC<any> | undefined> = {
    'datetime': DateTimeEditor,
    'date': DateTimeEditor,
    'string': DefaultEditor,
}

export const renderEditorForTypeAndOperator = (field: DataField, operator: string, props: HubspotFieldEditorProps): ReactNode => {
    if (field.type === 'enumeration' && field.originalField) {
        const options = (field.originalField as HSField).options;
        const isSubstitution = isSubstitutionPattern(props.value);

        return (
            <SelectorValue
                isSubstitution={isSubstitution}
                options={options.map(option => ({
                    key: option.value,
                    text: option.label,
                }))}
                plural={operator === 'IN'}
                {...props}
            />
        )
    }

    const Editor = typeEditorMap[field.type] || DefaultEditor;
    if (operator === 'BETWEEN') {
        return <RangeValueEditor EditorComponent={Editor} {...props} />
    }
    return <Editor {...props} />;
}

export const renderEditorForType = (field: DataField, props: HubspotFieldEditorProps): ReactNode => {
    if (field.type === 'enumeration' && field.originalField) {
        const options = (field.originalField as HSField).options;
        const isSubstitution = isSubstitutionPattern(props.value);

        return (
            <SelectorValue
                isSubstitution={isSubstitution}
                options={options.map(option => ({
                    key: option.value,
                    text: option.label,
                }))}
                plural={false}
                {...props}
            />
        )
    }

    const Editor = typeEditorMap[field.type] || DefaultEditor;

    return <Editor disableMultiply={true} {...props} />;
}

